import { createGlobalStyle, css } from 'styled-components';

const scrollbarStyle = css `

    ::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
    }

    ::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: transparent; 
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 2.5px;
        background-color: #B3BAC3;
        height: 120px;

        @media(min-width: 1920px){
            height: 400px;
        }
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #B3BAC3;
    }
`

export const ScrollbarTermsStyled = createGlobalStyle`
    ${scrollbarStyle};
`